exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-0841f88e] {\n  padding: 0;\n}\n.footer .container[data-v-0841f88e] {\n    display: block;\n    text-align: center;\n}\n.copyright a[data-v-0841f88e] {\n  color: #2b93ff;\n}\n.copyright a img[data-v-0841f88e] {\n    width: 100px;\n    margin-left: 5px;\n    margin-top: 5px;\n}\n", ""]);

// exports
